import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { ChipColorClass, TilledChipConfig } from 'app/shared/tilled-chip/tilled-chip.component';
import { Charge, PaymentIntent } from '../../../../../projects/tilled-api-client/src';

/**
 * Takes a PaymentIntent object and boolean to determine solid or opaque
 */
@Pipe({
  name: 'paymentStatus',
})
export class PaymentStatusPipe implements PipeTransform {
  constructor(private _currencyPipe: CurrencyPipe) {}

  /**
   *
   * @param payment PaymentIntent object
   * @param solid is the chip color solid (or opaque)
   * @returns
   */
  transform(payment: PaymentIntent, solid: boolean = false): TilledChipConfig {
    let chipConfig: TilledChipConfig = {
      color: ChipColorClass.SOLID_ACCENT,
      text: '',
      toolTip: '',
    };
    if (payment.status === PaymentIntent.StatusEnum.SUCCEEDED) {
      const successfulCharge = payment.charges.find((c) => c.status === Charge.StatusEnum.SUCCEEDED);
      if (successfulCharge.refunded) {
        chipConfig.color = solid ? ChipColorClass.SOLID_ACCENT : ChipColorClass.OPAQUE_ACCENT;
        chipConfig.text = 'REFUNDED';
        chipConfig.toolTip = 'The payment has been fully refunded.';
      } else if (successfulCharge.amount_refunded > 0) {
        chipConfig.color = solid ? ChipColorClass.SOLID_ACCENT : ChipColorClass.OPAQUE_ACCENT;
        chipConfig.text = 'PARTIAL REFUND';
        const refundAmountText = this._currencyPipe.transform(successfulCharge.amount_refunded / 100);
        chipConfig.toolTip = `${refundAmountText} was refunded.`;
      } else {
        chipConfig.color = solid ? ChipColorClass.SOLID_GREEN : ChipColorClass.OPAQUE_GREEN;
        chipConfig.text = 'SUCCEEDED';
        chipConfig.toolTip = 'This payment is complete.';
      }
    } else if (payment.status === PaymentIntent.StatusEnum.REQUIRES_PAYMENT_METHOD) {
      if (payment.charges.length > 0) {
        chipConfig.color = solid ? ChipColorClass.SOLID_RED : ChipColorClass.OPAQUE_RED;
        chipConfig.text = 'FAILED';
        chipConfig.toolTip = payment.last_payment_error?.message;
      } else {
        chipConfig.color = solid ? ChipColorClass.SOLID_ACCENT : ChipColorClass.OPAQUE_ACCENT;
        chipConfig.text = 'INCOMPLETE';
        chipConfig.toolTip = 'The payment method is required.';
      }
    } else if (payment.status === PaymentIntent.StatusEnum.PROCESSING) {
      chipConfig.color = solid ? ChipColorClass.SOLID_ACCENT : ChipColorClass.OPAQUE_ACCENT;
      chipConfig.text = 'PROCESSING';
    } else if (payment.status === PaymentIntent.StatusEnum.CANCELED) {
      chipConfig.color = solid ? ChipColorClass.SOLID_ACCENT : ChipColorClass.OPAQUE_ACCENT;
      chipConfig.text = 'CANCELED';
    } else if (payment.status === PaymentIntent.StatusEnum.REQUIRES_CAPTURE) {
      chipConfig.color = solid ? ChipColorClass.SOLID_ACCENT : ChipColorClass.OPAQUE_ACCENT;
      chipConfig.text = 'UNCAPTURED';
    } else if (payment.status === PaymentIntent.StatusEnum.REQUIRES_CONFIRMATION) {
      chipConfig.color = solid ? ChipColorClass.SOLID_ACCENT : ChipColorClass.OPAQUE_ACCENT;
      chipConfig.text = 'INCOMPLETE';
      chipConfig.toolTip = 'The payment requires confirmation.';
    } else if (payment.status === PaymentIntent.StatusEnum.REQUIRES_ACTION) {
      chipConfig.color = solid ? ChipColorClass.SOLID_ACCENT : ChipColorClass.OPAQUE_ACCENT;
      chipConfig.text = 'INCOMPLETE';
      chipConfig.toolTip = 'The payment requires additional actions.';
    } else {
      chipConfig.color = solid ? ChipColorClass.SOLID_ACCENT : ChipColorClass.OPAQUE_ACCENT;
      chipConfig.text = payment.status;
    }
    return chipConfig;
  }
}
